// 添加后端异常码映射
// 使用 Map 方式定义后端异常码映射
const backendErrorCodeMap = new Map<number, string>([
  [-1, "操作失败"],
  [200, "操作成功"],
  [400, "参数错误"],
  [401, "用户未登录"],
  [403, "无权访问"],
  [40100, "令牌过期"],
  [500, "服务异常"],
  [600, "业务验证异常"],
  [10100, "参数异常"],
  [10403, "未经授权的访问"],
  [10003, "数据库异常"],
  [10004, "缺少必要的参数"],
  [10005, "验证失败"],
  [10007, "更新失败"],
  [10008, "请提供token访问"],
  [10012, "远程文件服务调用失败"],
  [10015, "密码处理异常"],
  [10016, "当前令牌无效"],
  [10017, "没有访问权限"],
  [10018, "文件读取失败"],
  [10019, "时间转换异常"],
  [10020, "从Keycloak检索数据失败"],
  [10025, "私钥与密码不匹配"],
  [10026, "数据已存在，是否要还原"],
  [10027, "名称已存在"],
  [10051, "数据不存在"],
  [10052, "租户信息为空，请重试"],
  [10053, "该数据无法删除"],
  [10054, "查看设备端文件列表失败"],
  [10055, "远程KafkaConsumer服务调用失败"],
  [10057, "获取请求头失败"],
  [10058, "角色类型不正确，请重试"],
  [20014, "添加新类别的URL已经存在"],
  [20017, "验证码不正确"],
  [20025, "配置不存在"],
  [100027, "请先绘制流程图"],
]);

export const getErrorMessage = (errorCode: number): string => {
  return backendErrorCodeMap.get(errorCode) || `未知错误: ${errorCode}`;
};
